import React, { useRef, useState } from 'react';
import { Camera, X } from 'lucide-react';
import './ProfileUploadModal.css';

const ProfileUploadModal = ({
    isOpen,
    onClose,
    onCameraCapture,
    onFileUpload,
    studentData
}) => {
    const fileInputRef = useRef(null);
    const [isDragOver, setIsDragOver] = useState(false);

    if (!isOpen) return null;

    const handleFileSelect = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            onFileUpload(event);
            onClose();
        }
    };

    const handleCameraClick = () => {
        onCameraCapture();
        onClose();
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);

        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const file = files[0];
            if (file.type.startsWith('image/')) {
                // Create a synthetic event to pass to onFileUpload
                const syntheticEvent = {
                    target: {
                        files: [file],
                        value: ''
                    }
                };
                onFileUpload(syntheticEvent);
                onClose();
            } else {
                alert('Please select an image file.');
            }
        }
    };

    const handleGoToProfile = () => {
        onClose();
    };

    return (
        <div className="upload-modal-overlay" onClick={onClose}>
            <div className="upload-modal-container" onClick={(e) => e.stopPropagation()}>
                {/* Close button */}
                <button className="upload-modal-close-btn" onClick={onClose}>
                    <X size={24} />
                </button>

                <div className="upload-modal-content">
                    {/* Left sidebar */}
                    <div className="upload-modal-sidebar">
                        <div className="upload-modal-profile-section">
                            <div className="upload-modal-avatar">
                                {studentData?.profilePicPath ? (
                                    <img
                                        src={`https://pumotechnovationcrm.com${studentData.profilePicPath}`}
                                        alt="Profile"
                                        className="upload-modal-profile-image"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                ) : null}
                                <div className="upload-modal-default-avatar" style={{
                                    display: studentData?.profilePicPath ? 'none' : 'flex'
                                }}>
                                    <span className="upload-modal-avatar-text">
                                        {studentData?.name?.charAt(0) || 'U'}
                                    </span>
                                </div>
                            </div>

                            <div className="upload-modal-user-info">
                                <h3 className="upload-modal-username">{studentData?.name || 'User'}</h3>
                                <p className="upload-modal-user-id">{studentData?.studentId || 'ID'}</p>
                            </div>
                        </div>

                        <button className="upload-modal-profile-btn" onClick={handleGoToProfile}>
                            Go Back To Profile
                        </button>

                    </div>

                    {/* Right content */}
                    <div className="upload-modal-main">
                        <h2 className="upload-modal-title">Upload Your Photo</h2>

                        <div className="upload-modal-options">
                            {/* Capture Photo Option */}
                            <div className="upload-modal-option">
                                <button className="upload-modal-option-btn" onClick={handleCameraClick}>
                                    Capture Photo
                                </button>
                                <div className="upload-modal-option-box">
                                    <div
                                        className="upload-modal-option-content"
                                        onClick={handleCameraClick} // Click anywhere inside this box
                                        style={{ cursor: "pointer" }} // Optional: Makes it feel clickable
                                    >
                                        <Camera size={48} className="upload-modal-option-icon camera-icon" />
                                        <div className="upload-modal-file-types"></div>
                                    </div>
                                </div>
                            </div>


                            {/* Drag and Drop Option */}
                            <div className="upload-modal-option">
                                <button className="upload-modal-option-btn drag-btn" onClick={handleFileSelect}>
                                    Drop Your File
                                </button>
                                <div
                                    className={`upload-modal-option-box drag-zone ${isDragOver ? 'drag-over' : ''}`}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    onClick={handleFileSelect}
                                >
                                    <div className="upload-modal-option-content">
                                        <div className="upload-modal-plus-icon">+</div>
                                        <div className="upload-modal-file-types">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* Hidden file input */}
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{ display: 'none' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileUploadModal;